<template>
  <card>
    <loading
      name="lp"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <div class="row">
      <div class="col-3 mb-2">
        <badge
          rounded
          :type="
            task.status === 2
              ? 'info'
              : task.status === 3
              ? 'success'
              : 'danger'
          "
          >{{ task.statusname }}</badge
        >
      </div>
      <div class="col-9 mb-2" style="text-align: right">
        <base-button v-if="task.status === 3" type="primary" size="sm"
          >Show result</base-button
        >
        <base-button type="primary" size="sm" @click.native="onResponse">{{
          responsevisible ? "Close response" : "Response"
        }}</base-button>
      </div>
      <div class="col-lg-12">
        <h4>{{ task.classcode }}. {{ task.coursetitle }}</h4>
      </div>
      <div class="col-lg-10" style="font-size: 14px">
        <h5>{{ item.title }}</h5>
      </div>
      <div class="col-lg-6" v-if="task.status !== 3">
        <small :class="duedatecolor(task.duedate)"
          >Due date: {{ task.duedate }}</small
        >
      </div>

      <div class="col-lg-12" v-if="!responsevisible">
        <span
          style="font-size: 12px"
          v-html="htmldescription(item.description)"
        />
      </div>
    </div>
    <div v-if="!responsevisible">
        <hr v-if="task.files">
        
      <div v-for="file in task.files" :key="file.name" style="font-size: 12px">
        <a target="blank" :href="fileurl + file.name">
          <i class="text-black ni file-text"></i>
          {{ file.name.substring(file.name.indexOf("_") + 1) }}
        </a>
      </div>
    </div>
    <div class="row" v-if="responsevisible">
      <div class="col-lg-12">
        <base-input label="Please enter your response" class="mr-1">
          <textarea
            class="form-control"
            rows="4"
            resize="none"
            v-model="response.response"
          ></textarea>
        </base-input>
      </div>
      <div class="col-lg-12">
        <base-input
          type="text"
          label="Notes"
          placeholder="Notes"
          v-model="response.studentnotes"
          name="notes"
        ></base-input>
      </div>
      <div class="col-lg-12">
        <upload :sourcetype="2" :sourceId="response.id"  v-if="!response.publish"></upload>
        <div v-if="responsevisible">
            <hr v-if="task.files">
        
          <div
            v-for="file in task.responsefiles"
            :key="file.name"
            style="font-size: 12px"
          >
            <a target="blank" :href="fileurl + file.name">
              <i class="text-black ni file-text"></i>
              {{ file.name.substring(file.name.indexOf("_") + 1) }}
            </a>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <span v-if="response.publish">Published: {{ response.publish }}</span>
        <base-button v-else block type="success" @click="onSave"
          >Save and publish</base-button
        >
      </div>
    </div>
  </card>
</template>

<script>
import Upload from "../Upload";
import Badge from "@/components/Badge";
import {
  ShowLink,
  HtmlNewLine,
  fileUrl,
  DateTimeToString,
} from "../../../services/helper";
import { UpdateResponse, GetHomework } from "../../../services/homework";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "homework-item",
  computed: {
    fileurl() {
      return fileUrl;
    },
  },
  components: {
    Badge,
    Loading,
    Upload,
  },
  props: {
    item: Object,
  },
  data() {
    return {
      task: this.item,
      response: {},
      responsevisible: false,
      isLoading: false,
    };
  },
  methods: {
    htmldescription(value) {
      return ShowLink(HtmlNewLine(value));
    },
    duedatecolor(dt) {
      let d = new Date(dt);
      let n = new Date();
      if (parseInt((d - n) / (24 * 3600 * 1000)) > 2) return "text-success";
      else return "text-danger";
    },
    onResponse() {
      if (this.responsevisible) this.responsevisible = false;
      else {
        this.response = {
          id: this.task.id,
          response: this.task.response,
          studentnotes: this.task.studentnotes,
          publish: this.task.publish,
        };
        this.responsevisible = true;
      }
    },
    onSave() {
      this.isLoading = true;
      this.response.publish = DateTimeToString(new Date());
      UpdateResponse(this.response).then((response) => {
        this.isLoading = false;
        if (response.data.result) {
          GetHomework(this.response.id).then((h) => {
            if (h.data.result) {
              this.task = h.data.result;
            }
          });
          this.responsevisible = false;
        }
      });
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
</style>